import { render } from "./dsp-score.vue?vue&type=template&id=126b71ef"
import script from "./dsp-score.js?vue&type=script&lang=js"
export * from "./dsp-score.js?vue&type=script&lang=js"

import "./dsp-score.vue?vue&type=style&index=0&id=126b71ef&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__